const $lookBookList = $("#lookBookList");

/** List and Pagination */
const $dataUL = $(".new-look-book-data > ul");
const dataULSize = $dataUL.length;

/** routing */
const QUERY_PARAMETER_THEME_ID = "themeid";

$dataUL.each(function (index, elem) {
    const index1 = index + 1;
    var content = $(elem).html();
    content = content.replace(/tmpIndex/g, index1);
    if(index1 === 1) {
        $lookBookList.append("<ul class='look-book-list ul-" + index1 + "'>" + content + "</ul>");
    } else {
        $lookBookList.append("<ul style='display: none' class='look-book-list ul-" + index1 + "'>" + content + "</ul>");
    }
});

const $lookBookPagination = $("#lookBookPagination");
if(dataULSize <= 1) {
    $lookBookPagination.hide();
} else {
    $lookBookPagination.find(".max").text(dataULSize);
}

var currentUlIndex = 1;
const $lookBookLists = $(".look-book-list");
const $paginationCurrent = $lookBookPagination.find(".current");
const $htmlBody = $("html,body");
function switchList(index) {
    currentUlIndex = index;
    $lookBookLists.hide();
    $(".ul-" + currentUlIndex).show();
    $paginationCurrent.text(currentUlIndex);
    $htmlBody.scrollTop(0);
}

$lookBookPagination.find(".btn-prev").on("click", function (){
    const tmpIndex = currentUlIndex - 1;
    if(tmpIndex >= 1) {
        switchList(tmpIndex);
    }
});

$lookBookPagination.find(".btn-next").on("click", function (){
    const tmpIndex = currentUlIndex + 1;
    if(tmpIndex <= dataULSize) {
        switchList(tmpIndex);
    }
});

/** Sliders */
const $previewImageSlider = $(".preview-image-slider");
if($previewImageSlider.length) {
    $previewImageSlider.slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><img src="//arcteryx.jp/cdn/shop/t/244/assets/arrow-prev.svg?v=130598473545509783331771545780"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="//arcteryx.jp/cdn/shop/t/244/assets/arrow-next.svg?v=178496590611817706011771545780"></button>',
        lazyLoad: 'ondemand',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 750,
                settings: {
                    arrows: false,
                    dots: false,
                    fade: true
                }
            }
        ]
    });
}

const $navImageSlider = $(".nav-image-slider");
if($navImageSlider.length) {
    $navImageSlider.each((_, slider) => {
        const $slider = $(slider);

        $slider.slick({
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: $slider.find(".item-block").length - 1,
            lazyLoad: 'ondemand',
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><img src="//arcteryx.jp/cdn/shop/t/244/assets/arrow-prev.svg?v=130598473545509783331771545780"></button>',
            nextArrow: '<button type="button" class="slick-next"><img src="//arcteryx.jp/cdn/shop/t/244/assets/arrow-next.svg?v=178496590611817706011771545780"></button>',
            responsive: [
                {
                    breakpoint: 749,
                    settings: "unslick"
                }
            ]
        });

        $slider.find(".slick-slide").on("click", function (){
            const slickIndex = $(this).data("slick-index");
            if(slickIndex !== undefined) {
                const slick = $slider.slick("getSlick");
                if (slickIndex > 0) {
                    slick.slickGoTo(slickIndex - 1, false);
                } else {
                    slick.slickPrev();
                }
            }
        });

        $slider.on("afterChange", (e, slick, currentSlide) => {
            const centerSlide = currentSlide + 1 % slick.slideCount;
            $previewImageSlider.slick('slickGoTo', centerSlide, false);
        });
    });
}

/** Modal */
const modalConfig = {
    disableScroll: true,
    onShow: modal => {
        const $modal = $(modal);
        const gender = $modal.data("gender");
        const season = $modal.data("season");
        const themeId = $modal.data("theme-id");
        const themeName = $modal.data("theme-name");
        const pageTitle = $modal.data("page-title");
        const pageHandle = $modal.data("page-handle");

        if (themeId) {
            const url = new URL(location.href);
            url.searchParams.set(QUERY_PARAMETER_THEME_ID, themeId);
            history.replaceState(null, null, url.toString());
        }

        if(season && themeId) {
            dataLayer.push({
                'event': 'view_lookbook_modal',
                'gender': gender,
                'season': season,
                'theme_id': themeId,
                'theme_name': themeName,
                'page_title': pageTitle,
                'page_handle': pageHandle
            });
        }

        setTimeout((() => {
            $previewImageSlider.slick('setPosition');
            $navImageSlider.slick('setPosition');
            $productsSlider.slick('setPosition');
        }), 500);
    },
    onClose: modal => {
        const $modal = $(modal);
        const themeId = $modal.data("theme-id");

        if (themeId) {
            const url = new URL(location.href);
            if (url.searchParams.has(QUERY_PARAMETER_THEME_ID)) {
                url.searchParams.delete(QUERY_PARAMETER_THEME_ID);
                history.replaceState(null, null, url.toString());
            }
        }
    }
};
MicroModal.init(modalConfig);

/** モーダルの高さを可変にする */
function setFillHeight() {
    var height = window.innerHeight;
    if(window.innerWidth >= 750) {
        height = height - 70;
    } else {
        height = height - 50;
    }
    document.documentElement.style.setProperty("--modal-vh", height + "px");
}
window.addEventListener("resize", setFillHeight);
setFillHeight();

/* URLでテーマIDが指定されている場合、ページ表示時にモーダルを表示する */
window.addEventListener("load", () => {
    const url = new URL(location.href);
    if (!url.searchParams.has(QUERY_PARAMETER_THEME_ID)) {
        return;
    }

    const themeId = url.searchParams.get(QUERY_PARAMETER_THEME_ID);
    if (!themeId) {
        return;
    }

    const $modal = $(`.look-book-modal[data-theme-id="${themeId}"]`);
    const modalId = $modal.attr("id");
    if (modalId) {
        MicroModal.show(modalId, modalConfig);
    }
});